import Game from './Game';

export default class Hint {

    static current_id = 0;

    id: string;
    msg: string;
    points: number;
    used = false;

    constructor(msg: string, points = -5){
        this.id = `hint-${++Hint.current_id}`;
        this.msg = msg;
        this.points = points;

        console.log("Created hint " + this.id);
    }

    fake(){

        return this.msg.split('').map(c => {

            if(c === ' ') return c;

            return 'x';
        }).join('');

    }

    async useEvent(){
        console.log("useHint.", this.id);
        const game = await Game.current();
        game!.addEvent('useHint', this.id);
    }

    use(){
        this.used = true;

        (async()=>{
            const game = await Game.current();
            game!.points += this.points;
        })();
        
    }


}